export default __webpack_public_path__ + "static/lframe-contact-us-fcc08aa5d31e76949ef3e5510be208d6.png";